angular.module('pl-shared')
  .factory('preloadScript', function() {
    let pendingCount = 0
    const startPreload = () => pendingCount += 1
    const endPreload = (cb) => () => {
      pendingCount -= 1
      cb()
    }

    function scriptId(src) {
      if (src.includes('/polyfills.js')) return 'se-ui-libs-polyfills'
      // take src from first single slash to js extension and convert to snake-case
      return `preload${src.substring(src.indexOf('/', 8)).split('.js')[0].replace(/\/|_/g, '-')}`
    }

    function loadPending() {
      return pendingCount > 0
    }

    // Check to see if the script source is already injectd (special logic to only add one polyfill.js)
    function loaded(src) {
      return !!document.querySelector(`script#${scriptId(src)}`)
    }

    function load(src, async) {
      return new Promise((resolve, reject) => {
        if (loaded(src)) return resolve()

        const script = document.createElement('script')
        script.src = src
        script.id = scriptId(src)
        script.async = async !== false // undefined = true
        startPreload()
        script.onload = endPreload(resolve)
        script.onerror = endPreload(reject)
        document.body.appendChild(script)
      })
    }

    return { load, loadPending, loaded, scriptId }
  })
